import { Parser } from 'json2csv';

import rootStore from '@vromo/dashboard/src/stores/RootStore';

import sortBy from 'lodash/sortBy';
import { Column } from '../JobHistory/helpers/createCSVForJobs';
import { DriverReportViewData } from './helpers';

export default function createCSVForDrivers(driverData: {
    [key: string]: DriverReportViewData;
}): string {
    const { viewStore } = rootStore;

    const distUnits = viewStore.imperialUnits ? 'mi' : 'km';

    const parserOptions: { fields: Column<DriverReportViewData>[] } = {
        fields: [
            {
                label: 'Driver ID',
                value: (v) => v.id,
                default: ''
            },
            {
                label: 'Name',
                value: (v) => driverData[v.id!]!.name,
                default: ''
            },
            {
                label: 'Email',
                value: (v) => driverData[v.id!]!.email,
                default: ''
            },
            {
                label: 'Phone Number',
                value: (v) => driverData[v.id!]!.phone,
                default: ''
            },
            {
                label: 'External Id',
                value: (v) => v.external,
                default: ''
            },
            {
                label: 'Group',
                value: (v) => driverData[v.id!]!.group,
                default: ''
            },
            {
                label: 'Available Hours',
                value: (v) => driverData[v.id!]!.availableHours,
                default: ''
            },
            {
                label: 'Time on Job (Hours)',
                value: (v) => driverData[v.id!]!.timeOnJob,
                default: ''
            },
            {
                label: 'Jobs Completed',
                value: (v) => driverData[v.id!]!.jobsCompleted,
                default: ''
            },
            {
                label: 'Jobs Cancelled',
                value: (v) => driverData[v.id!]!.jobsCancelled,
                default: ''
            },
            {
                label: 'Jobs Re-offered',
                value: (v) => driverData[v.id!]!.jobsReoffered,
                default: ''
            },
            {
                label: `Total Distance (${distUnits})`,
                value: (v) => driverData[v.id!]!.totalTravel,
                default: ''
            },
            {
                label: `On Job Distance (${distUnits})`,
                value: (v) => driverData[v.id!]!.onJobTravel,
                default: ''
            },
            {
                label: `Average Rating`,
                value: (v) => driverData[v.id!]!.avgRating,
                default: ''
            },
            {
                label: `Pay Estimate`,
                value: (v) => driverData[v.id!]!.payEstimate,
                default: ''
            },
            {
                label: `Cost Per Job`,
                value: (v) => driverData[v.id!]!.costPerJob,
                default: ''
            }
        ]
    };

    const parser = new Parser(parserOptions);

    const contents = parser.parse(sortBy(Object.values(driverData), ['name']));

    return window.URL.createObjectURL(new Blob([contents]));
}
